import React from 'react'
import SuperAdminSidebar from './SuperAdminSidebar'
import SidebarV2 from '../../Components/Layout/SidebarV2';
import { MdOutlineDashboard } from 'react-icons/md';
import { GrOverview } from "react-icons/gr";


const SuperAdminLayout = () => {

    const navItems = [
        // Dashboard (admin only)
        {
            id: "dashboard",
            label: "Dashboard",
            icon: <MdOutlineDashboard size={16} />,
            path: "/super-admin/dashboard",
        },
        {
            id: "overview",
            label: "Overview",
            icon: <GrOverview size={16} />,
            path: "/super-admin/overview",
        },
        {
            id: "franchise",
            label: "Franchise",
            icon: <MdOutlineDashboard size={16} />,
            path: "/super-admin/franchise",
        },
        {
            id: "templates",
            label: "Templates",
            icon: <MdOutlineDashboard size={16} />,
            path: "/super-admin/templates",
        },


    ];


    return (
        // <SuperAdminSidebar />

        <SidebarV2 navItems={navItems} />
    )
}

export default SuperAdminLayout